import { LegendSection } from '../components/IconLegendModal';

export const dispatchLegendSections: LegendSection[] = [
  {
    title: 'Move Types',
    items: [
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-green-700 bg-green-100">Imp</span>,
        title: 'Import',
        description: 'Import shipment (inbound)',
      },
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-orange-700 bg-orange-100">Exp</span>,
        title: 'Export',
        description: 'Export shipment (outbound)',
      },
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-blue-700 bg-blue-100">Rail</span>,
        title: 'Rail',
        description: 'Rail shipment',
      },
    ],
  },
  {
    title: 'Delivery Types',
    items: [
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-blue-700 bg-blue-100">Drop</span>,
        title: 'Drop Delivery',
        description: 'Drop the container and leave',
      },
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-purple-700 bg-purple-100">Live</span>,
        title: 'Live Delivery',
        description: 'Wait while container is loaded/unloaded',
      },
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-yellow-700 bg-yellow-100">Ret</span>,
        title: 'Return Move',
        description: 'Return empty container to terminal/yard',
      },
      {
        icon: <span className="px-1.5 py-0.5 text-xs font-medium rounded text-cyan-700 bg-cyan-100">Pre</span>,
        title: 'Pre-Pull',
        description: 'Pick up container early before delivery appointment',
      },
    ],
  },
  {
    title: 'Order Requirements',
    items: [
      {
        icon: <span className="gw-icon gw-icon-hotjar text-red-500" style={{ fontSize: '24px' }}></span>,
        title: 'HOT Load',
        description: 'Time-sensitive shipment',
      },
      {
        icon: <span className="flaticon flaticon-warning text-orange-500" style={{ fontSize: '24px' }}></span>,
        title: 'Hazmat',
        description: 'Hazmat endorsement required',
      },
      {
        icon: <span className="flaticon flaticon-weight text-heading" style={{ fontSize: '24px' }}></span>,
        title: 'Overweight',
        description: 'Overweight permit required',
      },
      {
        icon: <span className="gw-icon gw-icon-early text-heading" style={{ fontSize: '24px' }}></span>,
        title: 'Early',
        description: 'Early appointment',
      },
      {
        icon: <span className="gw-icon gw-icon-dual-axle text-blue-600" style={{ fontSize: '24px' }}></span>,
        title: 'Triaxle',
        description: 'Triaxle chassis required',
      },
      {
        icon: <span className="gw-icon text-heading" style={{ fontSize: '24px' }}>&#xE9E5;</span>,
        title: '93K Triaxle',
        description: '93K triaxle chassis required',
      },
      {
        icon: <span className="flaticon flaticon-cargo text-purple-600" style={{ fontSize: '24px' }}></span>,
        title: 'Swing',
        description: 'Swing container',
      },
      {
        icon: <span className="flaticon flaticon-oil-tank text-purple-600" style={{ fontSize: '24px' }}></span>,
        title: 'Tank',
        description: 'Tank endorsement required',
      },
    ],
  },
  {
    title: 'Driver Qualifications',
    items: [
      {
        icon: <span className="gw-icon gw-icon-daycab text-blue-700" style={{ fontSize: '24px' }}></span>,
        title: 'Daycab',
        description: 'Driver has a daycab truck',
      },
      {
        icon: <span className="gw-icon gw-icon-hazmat text-orange-500" style={{ fontSize: '24px' }}></span>,
        title: 'Hazmat Certified',
        description: 'Driver has valid hazmat endorsement',
      },
      {
        icon: <span className="gw-icon gw-icon-tank text-purple-600" style={{ fontSize: '24px' }}></span>,
        title: 'Tank Endorsed',
        description: 'Driver has valid tank endorsement',
      },
      {
        icon: <span className="gw-icon text-heading" style={{ fontSize: '24px' }}>&#xE9E5;</span>,
        title: '93K Permitted',
        description: 'Driver has valid 93K permit',
      },
      {
        icon: (
          <span className="relative inline-flex items-center justify-center" style={{ width: '24px', height: '24px' }}>
            <span className="flaticon flaticon-weight text-green-600" style={{ fontSize: '24px' }}></span>
            <span className="absolute text-white font-bold" style={{ fontSize: '7px', bottom: '2px', right: '3px' }}>&lt;15K</span>
          </span>
        ),
        title: '< 15K Lbs',
        description: 'Truck weight under 15,000 lbs (required for some Kay Polymer loads)',
      },
    ],
  },
];
